import { ComponentProps } from 'react';
import clsx from 'clsx';

import styles from './StatItem.module.css';

interface StatItemProps extends ComponentProps<'div'> {
  label?: string;
  value?: string;
  note?: string;
  color?: 'light' | 'dark' | 'outline';
  height?: 'sm' | 'md' | 'lg';
}

const colorClassMap = {
  light: styles.light,
  dark: styles.dark,
  outline: styles.outline,
} as const;

const heightClassMap = {
  sm: styles.heightSm,
  md: styles.heightMd,
  lg: styles.heightLg,
} as const;

export default function StatItem({
  label,
  value,
  note,
  color = 'light',
  height = 'sm',
  className,
  ...props
}: StatItemProps) {
  return (
    <article
      className={clsx(styles.card, colorClassMap[color], heightClassMap[height], className)}
      {...props}
    >
      <div className={styles.header}>
        <p className={styles.value}>{value}</p>
        <h3 className={styles.label}>{label}</h3>
      </div>
      {note ? <p className={styles.note}>{note}</p> : null}
    </article>
  );
}
